import { storeNameList } from "../utils";

export const capitalizeFirstLetter = (string, userdata) => {
  if (string.length === 7) {
    return storeNameList[string];
  } else {
    let user = [];
    for (let key in userdata) {
      if (userdata[key].username === string) {
        user.push(userdata[key].fullname);
      }
    }
    return user.length > 0
      ? user[0]
      : string.charAt(0).toUpperCase() + string.slice(1).toLowerCase().slice(0, -11);
  }
};

export const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
